import React, { useEffect, useRef } from 'react';


import { X, Minimize2, Maximize2 } from 'lucide-react';





const FileViewer = ({ file, onClose, isMaximized, onToggleMaximize }) => {


  const iframeRef = useRef(null);




  useEffect(() => {


    if (iframeRef.current && file.htmlContent) {


      const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;


      iframeDoc.open();


      iframeDoc.write(file.htmlContent);


      iframeDoc.close();

    }


  }, [file.htmlContent]);




  const windowStyle = isMaximized


    ? 'inset-7 rounded-xl'


    : 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[85%] rounded-2xl';



  return (


    <div className="fixed inset-0 z-50 flex items-center justify-center">


      {/* Backdrop */}


      <div


        className="absolute inset-0 bg-black/20 backdrop-blur-sm"


        onClick={onClose}


      />





      {/* Window */}


      <div


        className={`absolute bg-white shadow-2xl overflow-hidden transition-all duration-300 ${windowStyle}`}


      >


        {/* Window Title Bar */}


        <div className="h-12 bg-gradient-to-b from-gray-100 to-gray-50 border-b border-gray-200 flex items-center justify-between px-4">


          <div className="flex items-center space-x-2">


            {/* macOS Window Controls */}


            <button


              onClick={onClose}


              className="w-3 h-3 rounded-full bg-red-500 hover:bg-red-600 transition-colors"


              aria-label="Close"


            />


            <button


              onClick={onToggleMaximize}


              className="w-3 h-3 rounded-full bg-yellow-500 hover:bg-yellow-600 transition-colors"


              aria-label="Minimize"


            />


            <button


              onClick={onToggleMaximize}


              className="w-3 h-3 rounded-full bg-green-500 hover:bg-green-600 transition-colors"


              aria-label="Maximize"


            />


          </div>


          <div className="flex-1 text-center">


            <span className="text-sm font-medium text-gray-700">{file.name}</span>


          </div>


          <div className="flex items-center space-x-2">


            <button


              onClick={onToggleMaximize}


              className="p-1 hover:bg-gray-200 rounded transition-colors"


              aria-label="Toggle maximize"


            >


              {isMaximized ? (


                <Minimize2 className="w-4 h-4 text-gray-600" />


              ) : (


                <Maximize2 className="w-4 h-4 text-gray-600" />


              )}


            </button>


            <button


              onClick={onClose}


              className="p-1 hover:bg-gray-200 rounded transition-colors"


              aria-label="Close window"


            >


              <X className="w-4 h-4 text-gray-600" />


            </button>


          </div>


        </div>





        {/* Browser-like Address Bar */}


        <div className="h-10 bg-gray-50 border-b border-gray-200 flex items-center px-4">


          <div className="flex-1 bg-white border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-600">


            file:///{file.filename}


          </div>


        </div>





        {/* Content Area - iframe */}


        <div className="flex-1 bg-white" style={{ height: 'calc(100% - 88px)' }}>


          <iframe


            ref={iframeRef}


            title={file.name}


            className="w-full h-full border-0"


            sandbox="allow-same-origin"


          />


        </div>


      </div>

    </div>

  );


};



export default FileViewer;
